<!-- Header -->
<app-header></app-header>

<!-- SideBar  -->
<app-sidebar></app-sidebar>
<div class="full-container">
  <router-outlet></router-outlet>
</div>
